import {Component, Inject, OnInit, OnDestroy, NgZone} from '@angular/core';
import {PrimeNGConfig} from 'primeng/api';
import {MenuService} from '../../shared/services/menu.service';
import {Router} from '@angular/router';
import {AppTabKey} from '../../shared/enums/app-tab-key';
import {DOCUMENT} from '@angular/common';
import {CommonUtility} from '../../shared/utility/common-utility';
import {PrivilegeService} from '../../shared/services/privilege.service';
import {UserService} from '../../shared/services/user/user.service';
import {AppConstant} from '../../shared/utility/app-constant';
import {Subscription} from 'rxjs';
import {Title} from '@angular/platform-browser';

export class MenuTypes {
  public menuTheme?: any;
  public menuMode?: any;
  public menuColor?: any;
  public textColor?: any;
}


@Component({
  selector: 'app-main',
  templateUrl: './app.main.component.html',
})

export class AppMainComponent implements OnInit, OnDestroy {
  public navSub?: Subscription;

  menuMode = 'slim';

  colorScheme = 'dark';
  menus: MenuTypes = new MenuTypes();

  menuTheme = 'layout-sidebar-bluegray';

  menuColor = '#455a64';

  textColor = '#fff';

  overlayMenuActive: boolean;

  staticMenuDesktopInactive: boolean;

  staticMenuMobileActive: boolean;

  menuClick: boolean;

  search = false;

  searchClick = false;

  userMenuClick: boolean;

  topbarUserMenuActive: boolean;

  notificationMenuClick: boolean;

  topbarNotificationMenuActive: boolean;

  rightMenuClick: boolean;

  rightMenuActive: boolean;

  configActive: boolean;

  configClick: boolean;

  resetMenu: boolean;

  menuHoverActive = false;

  inputStyle = 'outlined';

  ripple: boolean;

  menuThemes = [
    {textColor: '#495057', name: 'white', color: '#ffffff', logoColor: 'dark', componentTheme: null},
    {textColor: '#fff', name: 'darkgray', color: '#343a40', logoColor: 'white', componentTheme: null},
    {textColor: '#fff', name: 'blue', color: '#1976d2', logoColor: 'white', componentTheme: 'blue'},
    {textColor: '#fff', name: 'bluegray', color: '#455a64', logoColor: 'white', componentTheme: 'lightgreen'},
    {textColor: '#fff', name: 'brown', color: '#5d4037', logoColor: 'white', componentTheme: 'cyan'},
    {textColor: '#fff', name: 'cyan', color: '#0097a7', logoColor: 'white', componentTheme: 'cyan'},
    {textColor: '#fff', name: 'green', color: '#388e3C', logoColor: 'white', componentTheme: 'green'},
    {textColor: '#fff', name: 'indigo', color: '#303f9f', logoColor: 'white', componentTheme: 'indigo'},
    {textColor: '#fff', name: 'deeppurple', color: '#512da8', logoColor: 'white', componentTheme: 'deeppurple'},
    {textColor: '#000000', name: 'orange', color: '#F57c00', logoColor: 'dark', componentTheme: 'orange'},
    {textColor: '#fff', name: 'pink', color: '#c2185b', logoColor: 'white', componentTheme: 'pink'},
    {textColor: '#fff', name: 'purple', color: '#7b1fa2', logoColor: 'white', componentTheme: 'purple'},
    {textColor: '#fff', name: 'teal', color: '#00796b', logoColor: 'white', componentTheme: 'teal'},
  ];


  constructor(private menuService: MenuService, private primengConfig: PrimeNGConfig, public router: Router,
              private titleService: Title, @Inject(DOCUMENT) private document: Document, private privilegeService: PrivilegeService,
              private userService: UserService, private zone: NgZone) {
    new CommonUtility().updateGAnalytics(router, titleService, this.document);
  }

  ngOnDestroy() {
    this.userService.eulaMO?.disconnect();
    this.navSub?.unsubscribe();
  }

  /**
   * refresh EULA detector
   */
  installEulaDetector() {
    this.userService.eulaMO?.disconnect();
    this.zone.runOutsideAngular(() => {
      const check = () => {
        const host = document.querySelector('#eula-root');
        const hostPresent = !!host && (host as any).isConnected && document.body.contains(host);

        const overlay = document.querySelector('.eula-dialog');
        const overlayPresent = !!overlay && (overlay as any).isConnected && document.body.contains(overlay);

        if (!hostPresent || !overlayPresent) {
          this.zone.run(() => location.reload());
        }
      };
      requestAnimationFrame(check);

      this.userService.eulaMO = new MutationObserver(() => check());
      this.userService.eulaMO.observe(document.body, {childList: true, subtree: true});
    });
  }

  ngOnInit() {
    this.ripple = true;
    this.primengConfig.ripple = true;
    if (localStorage.getItem(AppTabKey.MENU_STATE_KEY)) {
      const menus: MenuTypes = JSON.parse(localStorage.getItem(AppTabKey.MENU_STATE_KEY));
      this.changeTheme(menus.menuMode, 'light');
      if (menus.menuTheme && !menus.menuColor) {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 1000);
        localStorage.removeItem(AppTabKey.MENU_STATE_KEY);
        return;
      }
      this.menuTheme = menus.menuTheme;
      this.menuColor = menus.menuColor;

      this.textColor = menus.textColor;
    } else {
      this.changeTheme('slim', 'light');
    }
    this.getEULA();
  }

  getEULA() {
    const user = JSON.parse(localStorage.getItem(AppConstant.SESSION_USER_ATTR));
    const support = this.privilegeService.isSupport();
    const vendor = this.privilegeService.isVendor();

    if (support || vendor) {
      return;
    }

    this.userService.getEulaVersionAcceptance(user.id, user.username).subscribe((res: any) => {
      this.userService.eulaTrigger.next(res.body === false);
      if (res.body === false) {
        setTimeout(() => {
          this.installEulaDetector();
        }, 500);
      }
    });
  }


  changeTheme(menu, theme) {
    this.menuMode = menu;
    this.colorScheme = theme;
    // this.changeColorScheme(theme);
  }

  // changeColorScheme(scheme) {
  //   localStorage.setItem('theme', scheme);
  //   this.changeStyleSheetsColor('layout-css', 'layout-' + scheme + '.css', 1);
  //   this.changeStyleSheetsColor('theme-css', 'theme-' + scheme + '.css', 1);
  //
  //   const mobileLogoLink: HTMLImageElement = document.getElementById('logo-mobile') as HTMLImageElement;
  //   const invoiceLogoLink: HTMLImageElement = document.getElementById('invoice-logo') as HTMLImageElement;
  //   const footerLogoLink: HTMLImageElement = document.getElementById('footer-logo') as HTMLImageElement;
  //
  //   if (scheme === 'light') {
  //     // mobileLogoLink.src = 'assets/layout/images/logo-dark.svg';
  //     // invoiceLogoLink.src = 'assets/layout/images/logo-dark.svg';
  //     // footerLogoLink.src = 'assets/layout/images/logo-dark.svg';
  //   } else {
  //     // mobileLogoLink.src = 'assets/layout/images/logo-white.svg';
  //     // invoiceLogoLink.src = 'assets/layout/images/logo-white.svg';
  //     // footerLogoLink.src = 'assets/layout/images/logo-white.svg';
  //   }
  // }

  // changeStyleSheetsColor(id, value, from) {
  //   const element = document.getElementById(id);
  //   const urlTokens = element.getAttribute('href').split('/');
  //
  //   if (from === 1) {           // which function invoked this function
  //     urlTokens[urlTokens.length - 1] = value;
  //   } else if (from === 2) {       // which function invoked this function
  //     if (value !== null) {
  //       urlTokens[urlTokens.length - 2] = value;
  //     }
  //   } else if (from === 3) {       // which function invoked this function
  //     urlTokens[urlTokens.length - 2] = value;
  //   }
  //
  //   const newURL = urlTokens.join('/');
  //
  //   this.replaceLink(element, newURL);
  // }

  // replaceLink(linkElement, href) {
  //   if (this.isIE()) {
  //     linkElement.setAttribute('href', href);
  //   } else {
  //     const id = linkElement.getAttribute('id');
  //     const cloneLinkElement = linkElement.cloneNode(true);
  //
  //     cloneLinkElement.setAttribute('href', href);
  //     cloneLinkElement.setAttribute('id', id + '-clone');
  //
  //     linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);
  //
  //     cloneLinkElement.addEventListener('load', () => {
  //       linkElement.remove();
  //       cloneLinkElement.setAttribute('id', id);
  //     });
  //   }
  // }

  // isIE() {
  //   return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
  // }
  onLayoutClick() {
    setTimeout(() => {
      if (!this.searchClick) {
        this.search = false;
      }

      if (!this.userMenuClick) {
        this.topbarUserMenuActive = false;
      }

      if (!this.notificationMenuClick) {
        this.topbarNotificationMenuActive = false;
      }

      if (!this.rightMenuClick) {
        this.rightMenuActive = false;
      }

      if (!this.menuClick) {
        if (this.isSlim()) {
          this.menuService.reset();
        }

        if (this.overlayMenuActive || this.staticMenuMobileActive) {
          this.hideOverlayMenu();
        }

        this.menuHoverActive = false;
        this.unblockBodyScroll();
      }

      if (this.configActive && !this.configClick) {
        this.configActive = false;
      }

      this.searchClick = false;
      this.configClick = false;
      this.userMenuClick = false;
      this.rightMenuClick = false;
      this.notificationMenuClick = false;
      this.menuClick = false;
    }, 100);
  }

  onMenuButtonClick(event) {
    this.menuClick = true;
    this.topbarUserMenuActive = false;
    this.topbarNotificationMenuActive = false;
    this.rightMenuActive = false;

    if (this.isOverlay()) {
      this.overlayMenuActive = !this.overlayMenuActive;
    }

    if (this.isDesktop()) {
      this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
    } else {
      this.staticMenuMobileActive = !this.staticMenuMobileActive;
      if (this.staticMenuMobileActive) {
        this.blockBodyScroll();
      } else {
        this.unblockBodyScroll();
      }
    }

    event.preventDefault();
  }

  onSearchClick(event) {
    this.search = !this.search;
    this.searchClick = !this.searchClick;
  }

  onMenuClick($event) {
    this.menuClick = true;
    this.resetMenu = false;
  }

  onTopbarUserMenuButtonClick(event) {
    this.userMenuClick = true;
    this.topbarUserMenuActive = !this.topbarUserMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onTopbarNotificationMenuButtonClick(event) {
    this.notificationMenuClick = true;
    this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onRightMenuClick(event) {
    this.rightMenuClick = true;
    this.rightMenuActive = !this.rightMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onRippleChange(event) {
    // this.ripple = event.checked;
  }

  onConfigClick(event) {
    this.configClick = true;
    window.dispatchEvent(new Event('resize'));
  }

  isSlim() {
    return this.menuMode === 'slim';
  }

  isOverlay() {
    return this.menuMode === 'overlay';
  }

  isDesktop() {
    return window.innerWidth > 991;
  }

  isMobile() {
    return window.innerWidth <= 991;
  }

  hideOverlayMenu() {
    this.overlayMenuActive = false;
    this.staticMenuMobileActive = false;
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    } else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
        'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }

  handleUserMenuClickChange(value: boolean) {
    this.userMenuClick = value;
  }

  handleUserMenuClickWithTrigger(value: boolean) {
    this.userMenuClick = value;
    this.onLayoutClick();
  }
}
